var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#496E2D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M300.522,245.325c-6.284,0-12.25,1.253-17.79,3.247c3.035-6.764,5.07-14.29,5.07-22.327 c0-31.801-31.801-55.652-31.801-55.652S224.2,194.444,224.2,226.245c0,8.036,2.035,15.563,5.07,22.327 c-5.541-1.992-11.507-3.247-17.79-3.247c-31.801,0-55.652,31.801-55.652,31.801s23.851,31.802,55.652,31.802 c18.645,0,34.547-10.928,44.522-19.974c9.975,9.045,25.877,19.974,44.522,19.974c31.801,0,55.652-31.802,55.652-31.802 S332.323,245.325,300.522,245.325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,100.174 262.569,120.39 283.826,120.39 266.631,132.886 273.195,153.102 256,140.606  238.805,153.102 245.369,132.886 228.174,120.39 249.431,120.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "175.167,135.533 187.805,146.911 202.532,138.409 195.616,153.944 208.253,165.324  191.341,163.546 184.425,179.081 180.887,162.448 163.976,160.67 178.702,152.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "115.994,194.707 132.628,198.242 141.131,183.515 142.909,200.426 159.541,203.964  144.007,210.881 145.785,227.791 134.404,215.156 118.87,222.072 127.373,207.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "336.833,135.533 324.196,146.911 309.469,138.409 316.384,153.944 303.748,165.324  320.66,163.546 327.576,179.081 331.114,162.448 348.025,160.67 333.299,152.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "396.007,194.707 379.373,198.242 370.871,183.515 369.092,200.426 352.46,203.964  367.994,210.881 366.216,227.791 377.597,215.156 393.131,222.072 384.628,207.344  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,397.972c25.261,0,48.545-8.428,67.223-22.609H188.778 C207.456,389.543,230.739,397.972,256,397.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M153.967,331.189c3.533,8.086,8.013,15.659,13.275,22.609H344.76 c5.262-6.949,9.742-14.523,13.275-22.609H153.967z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.51ecde2a5f8589bd80c731342965d032.svg";
export { ForwardRef as ReactComponent };